import React from "react";

export const WidgetCardContext = React.createContext({});
